/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import _ from 'lodash';

import { Assistant } from '../../../ts/assistant';
import { Skill } from '../../../ts/skill';
import { selectSkillReferencesFromAssistant } from '../../ia/store/assistants/core-selectors';
import { SKILL_TYPE } from '../../ia/store/skills/helper';

/**
 *
 * @param {Object} skill the skill object
 * @param {Object?} skill.type the type of the skill
 * @param {Object?} skill.dialog_settings dialog_settings attribute
 * @returns {boolean} return true if the skill is an actions skill. Otherwise, return false.
 */
export const isActionSkill = (skill: Partial<Skill>): boolean => {
  return (
    skill?.type === SKILL_TYPE.ACTION ||
    skill?.dialog_settings?.actions === true
  );
};

export const getActionsSkill = (
  assistant: Assistant,
  skillList: Skill[] = []
) => {
  if (selectSkillReferencesFromAssistant(assistant)?.length) {
    return _.find(
      selectSkillReferencesFromAssistant(assistant),
      skill_reference => {
        const targetSkill = skillList.find(
          skill => skill.skill_id === skill_reference.skill_id
        );
        return isActionSkill(targetSkill);
      }
    );
  }
  return null;
};
